import React, { useEffect, useState } from "react";
import {
  startOfToday,
  endOfToday,
  startOfWeek,
  endOfWeek,
  startOfMonth,
  endOfMonth,
  startOfYear,
  endOfYear,
} from "date-fns";

import { Link, withRouter, useParams, useHistory } from "react-router-dom";
import {
  Button,
  Card,
  CardBody,
  CardHeader,
  Col,
  Container,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  Form,
  FormFeedback,
  FormGroup,
  Input,
  Label,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Nav,
  NavItem,
  NavLink,
  Pagination,
  PaginationItem,
  PaginationLink,
  Progress,
  Row,
  TabContent,
  Table,
  TabPane,
  UncontrolledCollapse,
  UncontrolledDropdown,
} from "reactstrap";
import PropTypes from "prop-types";
import classnames from "classnames";
import { Swiper, SwiperSlide } from "swiper/react";
import SwiperCore, { Autoplay } from "swiper";

import Loader from "../../../Components/Common/Loader";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { withTranslation } from "react-i18next";
import axiosInstance from "../../../axiosConfig";

//Images
import profileBg from "../../../assets/images/profile-bg.jpg";
import light from "../../../assets/images/logo-light.png";

import BreadCrumb from "../../../Components/Common/BreadCrumb";

// Formik
import * as Yup from "yup";
import { useFormik } from "formik";

const CoursesAnnulees = (props) => {
  const history = useHistory();

  //Début code pour get la course sélectionnée
  const coursesSelected = useParams("id");

  SwiperCore.use([Autoplay]);

  function formatDate(date) {
    const dateObject = new Date(date).toLocaleDateString("fr-FR", {
      year: "numeric",
      month: "long",
      day: "numeric",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
      timeZoneName: "short",
    });
    return dateObject;
  }

  function statutColor(statut) {
    let color;
    switch (statut) {
      case "En attente":
        color = "warning";
        break;
      case "Accepter":
        color = "info";
        break;
      case "Pret":
        color = "primary";
        break;
      case "Commencer":
        color = "success";
        break;
      case "Terminer":
        color = "success";
        break;
      case "Annuler":
        color = "danger";
        break;
      default:
        color = "primary";
        break;
    }
    return color;
  }
  function convertDate(date) {
    return new Date(date);
  }

  const [activityTab, setActivityTab] = useState("3");

  const toggleActivityTab = (tab) => {
    if (activityTab !== tab) {
      setActivityTab(tab);
    }
  };

  const [coursesList, setCoursesList] = useState([]);
  const fetchCourseList = async () => {
    try {
      const course_list = await axiosInstance.get(`/coursedetail`);

      setCoursesList(
        course_list.data.data
          .filter((course) => course.course_status === "Annuler")
          .sort((a, b) => new Date(a.date_course) - new Date(b.date_course))
      );
      // console.log(course_list);
      // console.log("Course List: ", course_list.data.data);
    } catch (err) {
      console.error(err);
    }
  };

  useEffect(() => {
    try {
      fetchCourseList();
    } catch (error) {
      console.error("Erreur de fetch course: ", error);
    } finally {
      setTimeout(() => {
        setLoading(false);
      }, 2000);
    }
  }, []);

  const [loading, setLoading] = useState(true);
  const [coursesPeriod, setCoursesPeriod] = useState("");
  const [coursesPeriodList, setCoursesPeriodList] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [courseSelected, setCourseSelected] = useState({});

  const onChangeCoursesPeriod = (period = "") => {
    // console.log("coursesList: ", coursesList);

    // console.log("Period: ", period);
    let datedebut, datefin;
    let listFiltered = [];

    switch (period) {
      case "aujourd'hui":
        setCoursesPeriod("aujourd'hui");
        datedebut = startOfToday();
        datefin = endOfToday();
        break;
      case "semaine":
        setCoursesPeriod("semaine");
        datedebut = startOfWeek(new Date(), { weekStartsOn: 1 }); // Assuming the week starts on Monday
        datefin = endOfWeek(new Date(), { weekStartsOn: 1 });
        break;
      case "mois":
        setCoursesPeriod("mois");
        datedebut = startOfMonth(new Date());
        datefin = endOfMonth(new Date());
        break;
      case "an":
        setCoursesPeriod("an");
        datedebut = startOfYear(new Date());
        datefin = endOfYear(new Date());
        break;
      default:
        setCoursesPeriod("");
        datedebut = null;
        datefin = null;
        break;
    }

    if (datedebut && datefin) {
      // Conversion des dates en objets Date
      const dateDebut = convertDate(datedebut);
      const dateFin = convertDate(datefin);

      listFiltered = coursesList
        .filter(
          (course) =>
            convertDate(course.date_course) >= dateDebut &&
            convertDate(course.date_course) <= dateFin
        )
        .sort((a, b) => new Date(a.date_course) - new Date(b.date_course));
    } else {
      listFiltered = coursesList;
    }

    setCoursesPeriodList(listFiltered);

    // console.log("datedebut: ", datedebut);
    // console.log("datefin: ", datefin);
    return listFiltered;
    // console.log("list Filtered: ", listFiltered);
  };

  useEffect(() => {
    // console.log("courses Period List length: ", coursesPeriodList.length);
    onChangeCoursesPeriod();
  }, [coursesList]);

  // Recherche
  useEffect(() => {
    let list = onChangeCoursesPeriod(coursesPeriod);
    // console.log("list: ", list);

    const listFiltered =
      list &&
      list
        .filter(
          (course) =>
            (course.adresse_depart &&
              course.adresse_depart
                .toLowerCase()
                .includes(searchTerm.toLowerCase())) ||
            (course.adresse_destination &&
              course.adresse_destination
                .toLowerCase()
                .includes(searchTerm.toLowerCase())) ||
            (course.nom &&
              course.nom.toLowerCase().includes(searchTerm.toLowerCase())) ||
            (course.last_name_client &&
              course.last_name_client
                .toLowerCase()
                .includes(searchTerm.toLowerCase())) ||
            (course.last_name_conducteur &&
              course.last_name_conducteur
                .toLowerCase()
                .includes(searchTerm.toLowerCase())) ||
            (course.first_name_client &&
              course.first_name_client
                .toLowerCase()
                .includes(searchTerm.toLowerCase())) ||
            (course.first_name_conducteur &&
              course.first_name_conducteur
                .toLowerCase()
                .includes(searchTerm.toLowerCase()))
        )
        .sort((a, b) => new Date(a.date_course) - new Date(b.date_course));
    setCoursesPeriodList(listFiltered);
  }, [searchTerm, coursesList]);

  const [freeDriver, setFreeDriver] = useState([]);
  const getFreeDriver = async () => {
    try {
      const freeDriver = await axiosInstance.get(`/drivernocourse/`);
      const listFreeDriver = freeDriver.data.data.filter(
        (driver) =>
          driver.type_conducteur === "Conducteur" &&
          driver.type_engin === courseSelected.engin
      );
      // "Livreur";

      setFreeDriver(listFreeDriver);
      // console.log("freeDriver: ", freeDriver);
      return freeDriver;
    } catch (err) {
      console.error(err);
    }
  };

  const [modal, setModal] = useState(false);
  const [searchfreeDriver, setSearchFreeDriver] = useState(false);
  useEffect(() => {
    if (modal) {
      setSearchFreeDriver(true);
      getFreeDriver();
      setSearchFreeDriver(false);
    } else {
      fetchCourseList();
    }
  }, [modal]);

  // validation
  const validation = useFormik({
    // enableReinitialize : use this flag when initial values needs to be changed
    enableReinitialize: true,

    initialValues: {
      driver: "",
    },
    validationSchema: Yup.object({
      driver: Yup.string().required(
        props.t("Veuillez renseigner le chauffeur")
      ),
    }),
    onSubmit: async (values) => {
      // console.log("driver: ", values.driver);

      const assign_driver = {
        user_id: values.driver,
        course_id: courseSelected.id,
      };
      // console.log("assign_driver: ", assign_driver);

      // try {
      //   const data = axiosInstance
      //     .put(
      //       `/attribuconducteurcourse/?id=${courseSelected.id}`,
      //       assign_driver
      //     )
      //     .then((response) => {
      //       console.log("response: ", response);
      //       // dispatch(onUpdateChauffeur(updateChauffeur));
      //       validation.resetForm();
      //       toast.success(
      //         props.t("Le chauffeur a été assigné à cette course avec succès"),
      //         {
      //           autoClose: 3000,
      //         }
      //       );
      //     })
      //     .catch((error) => {
      //       toast.error(
      //         props.t("Echec d'assignation du Chauffeur à la course"),
      //         {
      //           autoClose: 3000,
      //         }
      //       );
      //     });

      //   // window.location.reload(true);
      // } catch (err) {
      //   console.log(err);
      //   toast.error(props.t("Echec d'assignation du Chauffeur à la course"), {
      //     autoClose: 2000,
      //   });
      // }
      const locationRedirection = `/courses#${courseSelected.id}`;
      // console.log("locationRedirection: ", locationRedirection);
      setCourseSelected({});
      await fetchCourseList();
      await getFreeDriver();
      setModal(false);
      history.push(`${locationRedirection}`);
    },
  });

  // function getUniqueStatuses(courses) {
  //   const statuses = courses.map((course) => course.course_status);
  //   return [...new Set(statuses)]; // Supprime les doublons
  // }
  // useEffect(() => {
  //   const statut_course = getUniqueStatuses(coursesList);
  //   console.log("statut_course: ", statut_course);
  // }, [coursesList]);

  document.title = "Courses annulées | Takci";

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <BreadCrumb
            title={props.t("Courses annulées")}
            pageTitle="Courses"
            pageTitleLink="/course"
          />

          <div className="profile-foreground position-relative mx-n4 mt-n4">
            <div className="profile-wid-bg">
              <img src={profileBg} alt="" className="profile-wid-img" />
            </div>
          </div>

          <div className="pt-4 mb-4 mb-lg-3 pb-lg-4">
            <Row className="g-4" style={{ justifyContent: "center" }}>
              <div className="col-auto">
                <div
                  className="avatar-lg"
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <img src={light} alt="user-img" width="100px" />
                </div>
              </div>
            </Row>
          </div>

          <div>
            <Row>
              <Col xxl={12}>
                <Row>
                  <Col lg={12}>
                    <Card>
                      <CardHeader className="align-items-center">
                        <div className="d-flex align-items-center">
                          <h4 className="card-title mb-0  me-2">
                            Courses annulées {coursesPeriod}{" "}
                            {coursesPeriodList &&
                              `(${coursesPeriodList.length})`}
                          </h4>
                          <div className="flex-shrink-0 ms-auto">
                            <div className="justify-content-end d-none d-md-flex gap-1">
                              <button
                                disabled={coursesPeriod === ""}
                                className="btn"
                                style={{
                                  background: "#002437",
                                  color: "white",
                                }}
                                onClick={(e) => {
                                  e.preventDefault();
                                  onChangeCoursesPeriod("tous");
                                }}
                              >
                                {props.t("Tous")}
                              </button>

                              <button
                                disabled={coursesPeriod === "aujourd'hui"}
                                className="btn"
                                style={{
                                  background: "#002437",
                                  color: "white",
                                }}
                                onClick={(e) => {
                                  e.preventDefault();
                                  onChangeCoursesPeriod("aujourd'hui");
                                }}
                              >
                                {props.t("Today")}
                              </button>

                              <button
                                disabled={coursesPeriod === "semaine"}
                                className="btn"
                                style={{
                                  background: "#002437",
                                  color: "white",
                                }}
                                onClick={(e) => {
                                  e.preventDefault();
                                  onChangeCoursesPeriod("semaine");
                                }}
                              >
                                {props.t("Week")}
                              </button>

                              <button
                                disabled={coursesPeriod === "mois"}
                                className="btn"
                                style={{
                                  background: "#002437",
                                  color: "white",
                                }}
                                onClick={(e) => {
                                  e.preventDefault();
                                  onChangeCoursesPeriod("mois");
                                }}
                              >
                                {props.t("Month")}
                              </button>

                              <button
                                disabled={coursesPeriod === "an"}
                                className="btn"
                                style={{
                                  background: "#002437",
                                  color: "white",
                                }}
                                onClick={(e) => {
                                  e.preventDefault();
                                  onChangeCoursesPeriod("an");
                                }}
                              >
                                {props.t("Year")}
                              </button>
                            </div>
                            <FormGroup className="d-block d-md-none">
                              <Input
                                id="exampleSelect"
                                name="select"
                                type="select"
                                onChange={(e) =>
                                  onChangeCoursesPeriod(e.target.value)
                                }
                              >
                                <option
                                  selected
                                  disabled={coursesPeriod === ""}
                                  className="btn"
                                  style={{
                                    background: "#002437",
                                    color: "white",
                                  }}
                                  value="tous"
                                >
                                  {props.t("Tous")}
                                </option>

                                <option
                                  disabled={coursesPeriod === "aujourd'hui"}
                                  className="btn"
                                  style={{
                                    background: "#002437",
                                    color: "white",
                                  }}
                                  value="aujourd'hui"
                                >
                                  {props.t("Today")}
                                </option>

                                <option
                                  disabled={coursesPeriod === "semaine"}
                                  className="btn"
                                  style={{
                                    background: "#002437",
                                    color: "white",
                                  }}
                                  value="semaine"
                                >
                                  {props.t("Week")}
                                </option>

                                <option
                                  disabled={coursesPeriod === "mois"}
                                  className="btn"
                                  style={{
                                    background: "#002437",
                                    color: "white",
                                  }}
                                  value="mois"
                                >
                                  {props.t("Month")}
                                </option>

                                <option
                                  disabled={coursesPeriod === "an"}
                                  className="btn"
                                  style={{
                                    background: "#002437",
                                    color: "white",
                                  }}
                                  value="an"
                                >
                                  {props.t("Year")}
                                </option>
                              </Input>
                            </FormGroup>
                          </div>
                        </div>
                        <div className="flex-shrink-0 ms-auto mt-3">
                          <div className="justify-content-end gap-1">
                            <Input
                              readOnly={coursesList.length <= 0}
                              type="text"
                              placeholder="Rechercher..."
                              value={searchTerm}
                              onChange={(e) => setSearchTerm(e.target.value)}
                            />
                          </div>
                        </div>
                      </CardHeader>
                      <CardBody>
                        <div>
                          <div className="profile-timeline">
                            <div></div>
                            <div
                              className="accordion accordion-flush"
                              // id="headingOne"
                            >
                              {!loading ? (
                                coursesPeriodList &&
                                coursesPeriodList.length > 0 ? (
                                  coursesPeriodList.map((course, key) => {
                                    return (
                                      <div
                                        className="accordion-item border-0"
                                        key={key}
                                      >
                                        <div
                                          className="accordion-header"
                                          id={`heading${key}`}
                                        >
                                          <Link
                                            to="#"
                                            className="accordion-button p-2 shadow-none"
                                            id="collapseTwo"
                                          >
                                            <div className="d-flex">
                                              <div
                                                className="flex-shrink-0"
                                                style={{
                                                  display: "flex",
                                                  justifyContent: "center",
                                                  alignItems: "center",
                                                }}
                                              >
                                                <i
                                                  className={`bx bx-${
                                                    course.type_engin_id === 1
                                                      ? "car"
                                                      : course.type_engin_id ===
                                                        1
                                                      ? ""
                                                      : "cycling"
                                                  } avatar-xs rounded-circle`}
                                                  style={{
                                                    border: "1px solid #002437",
                                                    background: "white",
                                                    fontSize: "2rem",
                                                  }}
                                                />
                                              </div>
                                              <div className="flex-grow-1 ms-3">
                                                <Row className="w-100 fs-14 mb-1 d-flex justify-content-between">
                                                  <Col xxl={9}>
                                                   Course 
                                                    {course.engin_designation}{" "}
                                                    {course?.engin_classe}
                                                  </Col>

                                                  <Col
                                                    xxl={3}
                                                    className={`justify-content-end`}
                                                  >
                                                    <span
                                                      className={`badge bg-soft-${statutColor(
                                                        course.course_status
                                                      )} text-${statutColor(
                                                        course.course_status
                                                      )} align-middle`}
                                                    >
                                                      {course.course_status}
                                                    </span>
                                                  </Col>
                                                </Row>
                                                <small className="text-muted">
                                                  {course.adresse_depart}
                                                  {" -- "}
                                                  {course.adresse_destination}
                                                </small>
                                              </div>
                                            </div>
                                          </Link>
                                        </div>
                                        <UncontrolledCollapse
                                          className="accordion-collapse"
                                          toggler={`#heading${key}`}
                                          defaultOpen={key === 0}
                                        >
                                          <div className="accordion-body ms-2 ps-5">
                                            <ul className="list-unstyled text-muted vstack gap-3">
                                              <li>
                                                <div className="d-flex">
                                                  <div className="flex-shrink-0 text-secondary me-1">
                                                    <i className="bx bx-trip fs-15 align-middle"></i>
                                                  </div>
                                                  <div className="flex-grow-1">
                                                    <b>Date: </b>
                                                    {formatDate(
                                                      course.date_course
                                                    )}
                                                  </div>
                                                </div>
                                              </li>

                                              <li>
                                                <div className="d-flex">
                                                  <div className="flex-shrink-0 text-secondary me-1">
                                                    <i className="bx bx-trip fs-15 align-middle"></i>
                                                  </div>
                                                  <div className="flex-grow-1">
                                                    <b>Départ: </b>
                                                    {course.adresse_depart}
                                                  </div>
                                                </div>
                                              </li>
                                              <li>
                                                <div className="d-flex">
                                                  <div className="flex-shrink-0 text-secondary me-1">
                                                    <i className="bx bx-trip fs-15 align-middle"></i>
                                                  </div>
                                                  <div className="flex-grow-1">
                                                    <b>Destination: </b>
                                                    {course.adresse_destination}
                                                  </div>
                                                </div>
                                              </li>

                                              <li>
                                                <div className="d-flex">
                                                  <div className="flex-shrink-0 text-secondary me-1">
                                                    <i className="ri-subtract-line fs-15 align-middle"></i>
                                                  </div>
                                                  <div className="flex-grow-1">
                                                    <b>Type d'engin: </b>
                                                    {/* {course.type_engin_id} */}
                                                    {course.engin_designation}{" "}
                                                    {course?.engin_classe}
                                                  </div>
                                                </div>
                                              </li>

                                              <li>
                                                <div className="d-flex">
                                                  <div className="flex-shrink-0 text-secondary me-1">
                                                    <i className="ri-subtract-line fs-15 align-middle"></i>
                                                  </div>
                                                  <div className="flex-grow-1">
                                                    <b>Distance: </b>
                                                    {course.distance_estimee ||
                                                      0}
                                                    {" Km"}
                                                  </div>
                                                </div>
                                              </li>

                                              <li>
                                                <div className="d-flex">
                                                  <div className="flex-shrink-0 text-secondary me-1">
                                                    <i className="ri-subtract-line fs-15 align-middle"></i>
                                                  </div>
                                                  <div className="flex-grow-1">
                                                    <b>Client: </b>
                                                    <Link
                                                      to={`client/${course.client_id}`}
                                                    >
                                                      {course.first_name_client}{" "}
                                                      {course.last_name_client}
                                                    </Link>
                                                  </div>
                                                </div>
                                              </li>
                                            </ul>
                                          </div>
                                        </UncontrolledCollapse>
                                      </div>
                                    );
                                  })
                                ) : (
                                  <div className="text-center my-3">
                                    <h2>Pas de Courses</h2>
                                  </div>
                                )
                              ) : (
                                <div className="text-center my-3">
                                  <Loader style={{ color: "#014c94" }} />
                                  <h2>Chargement...</h2>
                                </div>
                              )}
                            </div>
                          </div>
                        </div>
                      </CardBody>
                    </Card>
                  </Col>
                </Row>
              </Col>
            </Row>
          </div>
        </Container>

        <Modal id="showModal" style={{ maxWidth: 800 }} isOpen={modal} centered>
          <ModalHeader className="bg-soft-info p-3">
            Assigner un chauffeur à une course
          </ModalHeader>
          <Form
            onSubmit={async (e) => {
              e.preventDefault();
              validation.handleSubmit();
              // setModal(false);
              // await fetchCourseList();
              // await getFreeDriver();
            }}
          >
            <ModalBody>
              <Row className="g-3">
                <Col lg={12}>
                  <div>
                    <Label htmlFor="driver" className="form-label">
                      {props.t("Free Driver")}{" "}
                      <span style={{ color: "red" }}>*</span>
                    </Label>
                    {!searchfreeDriver ? (
                      <>
                        <Input
                          type="select"
                          name="driver"
                          id="driver"
                          className="form-control"
                          validate={{
                            required: { value: true },
                          }}
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          defaultValue={validation.values.driver || ""}
                          invalid={
                            validation.touched.driver &&
                            validation.errors.driver
                              ? true
                              : false
                          }
                        >
                          <option selected disabled value="">
                            {props.t("Free Driver")}
                            {"*"}
                          </option>

                          {freeDriver.map((driver, key) => {
                            return (
                              <>
                                <option key={key} value={`${driver.user_id}`}>
                                  {driver.first_name} {driver.last_name}
                                  :: {driver.type_engin}
                                </option>
                              </>
                            );
                          })}
                        </Input>
                        {validation.touched.driver &&
                        validation.errors.driver ? (
                          <FormFeedback type="invalid">
                            {validation.errors.driver}
                          </FormFeedback>
                        ) : null}
                      </>
                    ) : (
                      <div className="text-center my-3 d-flex">
                        <Loader style={{ color: "#014c94" }} />
                        Chargement des conducteurs libres...
                      </div>
                    )}
                  </div>
                </Col>
              </Row>
            </ModalBody>

            <ModalFooter>
              <div className="hstack gap-2 justify-content-end">
                <Button
                  type="button"
                  onClick={async () => {
                    setModal(false);
                    await fetchCourseList();
                    await getFreeDriver();
                  }}
                  className="btn-light"
                >
                  {props.t("Fermer")}
                </Button>

                <Button
                  type="submit"
                  className="btn"
                  style={{ background: "#002437", color: "white" }}
                  id="assign-btn"
                >
                  Assigner le Chauffeur
                </Button>
              </div>
            </ModalFooter>
          </Form>
        </Modal>

        <ToastContainer closeButton={false} />
      </div>
    </React.Fragment>
  );
};

CoursesAnnulees.propTypes = {
  location: PropTypes.object,
  t: PropTypes.any,
};
export default withRouter(withTranslation()(CoursesAnnulees));
